import { ref } from 'vue';
import { ProductSpotModel, ProductClientService } from '@/types/productServerApi';
import utilities from '@/shared/utilities.service';

export default function useProductsFromSameSeries() {
    const products = ref<ProductSpotModel[]>([] as ProductSpotModel[]);

    const getProductsFromSameSeries = async(id: string): Promise<ProductSpotModel[] | undefined> => {
        const response = await ProductClientService.getProductsFromSameSeries(id)
            .then(utilities.unwrapModel);
        products.value = response ?? [] as ProductSpotModel[];
        return products.value;
    };

    return {
        products,
        getProductsFromSameSeries,
    };
}
